import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SsoAccountInfoModel } from '../model/sso-account-info.model';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})


export class AuthService {

  private tokenKey = 'auth-token';
  private isUserAuthenticated = false;
  ActiveLink: string = ''
  constructor(private http: HttpClient, private route: ActivatedRoute) { }



  login(username: string, password: string): Observable<any> {
    return this.http.post(environment.baseUrl + 'Login/token', { username, password }).pipe(map(res => res));
  }
  sendUserInfo(data: SsoAccountInfoModel): Observable<any> {
    const headers = new HttpHeaders({
      'ApiKey': 'wmBCUWH9LUY4SvxbLCoB/vSFRMpjdVhLp51b4vQ9PPgirmAJqH53yx9jjlTvXjl0',
    });
    const options = { headers: headers };
    return this.http.post(environment.baseUrl + 'Login/tokensso', data, options).pipe(map(res => res));

  }
  getGroup() {
    return this.http.get<any>(environment.apiConfig.uri + '/me/transitiveMemberOf/microsoft.graph.group?$count=true&$top=999')
  }

  getToken(): any {
    return localStorage.getItem(this.tokenKey);
  }

  isAuthenticated(): boolean {
    if (localStorage.getItem(this.tokenKey)) {
      return true
    } else {
      return this.isUserAuthenticated;
    }

  }

  setAuthenticatedStatus(status: boolean) {
    this.isUserAuthenticated = status;
  }


  hasAccess(route: string): boolean {
    const userPermissions = JSON.parse(localStorage.getItem('menuData') || '{}');
    if (userPermissions.length !== 0) {
      const hasRole = userPermissions.some((item: { features: { featureUrl: string; }[]; }) => {
        return item.features.some((feature: { featureUrl: string; }) => feature.featureUrl === "/" + route);
      });
      return hasRole
    } else {
      return false;
    }
  }

  hasAccessRoute(route: string): boolean {
    const userPermissions = JSON.parse(localStorage.getItem('menuDataAll') || '{}');
    if (userPermissions.length !== 0) {
      const hasRole = userPermissions?.some((item: any) => {
        return item.FeatureUrl?.trim() === route?.trim()
      });
      return hasRole
    } else {
      return false;
    }
  }

  getAllFeaturesByCurrentUser() {
    return this.http.get<any>(environment.baseUrl + 'Login/getAllFeaturesByCurrentUser')
  }
}
